import type { NavSectionProps } from 'src/components/nav-section';

import { useEffect } from 'react';

import Box from '@mui/material/Box';
import Drawer, { drawerClasses } from '@mui/material/Drawer';

import { usePathname } from 'src/routes/hooks';

import { Logo } from 'src/components/logo';
import { Scrollbar } from 'src/components/scrollbar';
import { NavSectionVertical } from 'src/components/nav-section';

import { useAuthContext } from 'src/auth/hooks';

import { navData } from '../config-nav-dashboard';
import { filterDashboardNavForUser } from './generic';

// ----------------------------------------------------------------------

type NavMobileProps = Omit<NavSectionProps, 'data'> & {
  data?: NavSectionProps['data'];
  open: boolean;
  onClose: () => void;
  slots?: {
    topArea?: React.ReactNode;
    bottomArea?: React.ReactNode;
  };
};

export function NavMobile({ data, open, onClose, slots, sx, ...other }: NavMobileProps) {
  const pathname = usePathname();
  const { userProfile } = useAuthContext();
  const filteredData = filterDashboardNavForUser(navData.main, userProfile ?? null);

  useEffect(() => {
    if (open) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      sx={{
        [`& .${drawerClasses.paper}`]: {
          overflow: 'unset',
          bgcolor: 'var(--layout-nav-bg)',
          width: 'var(--layout-nav-mobile-width)',
          ...sx,
        },
      }}
    >
      {slots?.topArea ?? (
        <Box sx={{ pl: 3.5, pt: 2.5, pb: 1 }}>
          <Logo />
        </Box>
      )}

      <Scrollbar fillContent sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
        <NavSectionVertical data={filteredData} sx={{ px: 2, flex: '1' }} {...other} />

        <Box sx={{ mt: 'auto', px: 2, mb: 2 }}>
          <NavSectionVertical data={navData.bottom} sx={{ flex: '0' }} {...other} />
        </Box>
      </Scrollbar>

      {slots?.bottomArea}
    </Drawer>
  );
}
